// extracted by mini-css-extract-plugin
module.exports = {"tag__roundBox":"tag__roundBox--3SG0b","tag__title":"tag__title--u38hB","tag__closeButton":"tag__closeButton--228_9","tag__icon":"tag__icon--2oiIc"};